import customerFeedbackInputData from './inputData/demo-feedback-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'demo-feedback-form',
  title: 'Demo Feedback Form',
  description: 'Gather clear, honest input from users after a demo so you can improve the experience and better showcase your product.',
  image: '/images/templates/demo-feedback-form.png',
  tags: ['get-feedback', 'product'],
  inputData: customerFeedbackInputData,
  formPreview: convertDraftParamsToLeadForm(customerFeedbackInputData(),
    previewInput
  ),
}

export default template;

